import { slaStatus } from '@shared/sla';
import type { Incident } from '@shared/types';

const LABEL = { ok: 'On track', 'at-risk': 'At risk', breached: 'Breached', paused: 'Paused', met: 'Met' } as const;

export function SlaPill({ incident }: { incident: Incident }) {
  const resolved = incident.state === 'Resolved' || incident.state === 'Closed' || incident.state === 'Cancelled';
  const s = slaStatus(incident.sla, new Date(), incident.createdAt?.toDate?.() ?? new Date(), resolved);
  const cls = s === 'breached' ? 'badge-cancelled' : s === 'at-risk' ? 'badge-inprogress' : s === 'paused' ? 'badge-onhold' : 'badge-resolved';
  const due = incident.sla.resolveDue ? ` · due ${incident.sla.resolveDue.toDate().toLocaleString()}` : '';
  return <span className={`badge ${cls}`} title={`SLA ${LABEL[s]}${due}`}>{LABEL[s]}</span>;
}
